export default "__VITE_ASSET__BNHhgM7V__"